import getCurrency from '../../legacy/locales/get_currency'

const formatCurrency = options => getCurrency(options)

export { formatCurrency }
